module.exports = __webpack_public_path__ + "static/media/smartphone-chip.79bfaa18.svg";